<template>
  <div class="card-item transition-slow">
    <div class="info-content">
      <div class="info-item">
        <router-link class="return-link" :to="{name: 'login'}">
          <!-- <span :class="'fas fa-arrow-left'" /> Volver -->
          <span :class="'fas fa-arrow-left'" /> {{ $t('resetPassword.back') }}
        </router-link>
        <!-- <h2 class="login-title">Recuperar contraseña</h2> -->
        <h2 class="login-title">{{ $t('resetPassword.title') }}</h2>
        <!-- <p class="description-password">
          Ingresa tu correo electrónico y te enviaremos las instrucciones para recuperar tu contraseña
        </p> -->
        <p class="description-password">
          {{ $t('resetPassword.descriptionPassword') }}
        </p>
        <form @submit.prevent="onSubmit">
          <TextInput
            :id="'email'"
            v-model="email"
            :label="$t('resetPassword.email')"
            :type="'email'"
            :icon="'fa-envelope'"
            :error="email === '' && errorMessage != ''" />
          <p
            class="error-message transition-fast"
            :class="errorMessage !== '' ? 'show-error' : ''"
            v-html="errorMessage" />
          <div v-if="userResponse" class="message-reply">{{ userResponse }}</div>
          <!-- <button id="resetButton" class="button is-button-primary transition-fast is-rounded" type="submit">Enviar</button> -->
          <button id="resetButton" class="button is-button-primary transition-fast is-rounded" type="submit">{{ $t('resetPassword.send') }}</button>
        </form>
        <!-- <p class="description-help">
          ¿Tienes dudas? Visita nuestro <a href="http://ayuda.creditu.com">Centro de Ayuda</a>
        </p> -->
        <p class="description-help">
          {{ $t('resetPassword.descriptionHelpDoubts') }} <a href="http://ayuda.creditu.com">{{ $t('resetPassword.descriptionHelpCenter') }}</a>
        </p>
      </div>
      <div class="spinner-content" :class="isLoading ? 'is-loading' : ''">
        <div class="spinner">
          <div class="double-bounce1" />
          <div class="double-bounce2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authenticationService } from '@/application/services/api-clients/login-service';
import TextInput from '@/ui/components/input/TextInput.vue';

export default {
  name: 'ResetPassword',
  components: { TextInput },
  data() {
    return {
      email: '',
      errorMessage: '',
      isLoading: false,
      userResponse: ''
    };
  },
  created() {
    if (this.$store.state.currentUser) {
      this.$router.push({ name: 'main' });
    }
    this.returnUrl = this.$route.query.returnUrl || 'main';
  },
  methods: {
    async onSubmit() {
      try {
        this.errorMessage = '';
        this.userResponse = '';
        this.isLoading = true;
        if (!this.email) {
          /* this.errorMessage = 'Este campo no puede estar vacío'; */
          this.errorMessage = this.$t('resetPassword.fieldEmpty');
          this.isLoading = false;
          return;
        }
        const response = await authenticationService.restorePassword(this.email);
        /* this.userResponse = response.data ? 'Te enviamos un correo con tu contraseña' : 'Tu correo no se encuentra registrado'; */
        this.userResponse = response.data ? this.$t('resetPassword.sendPassword') : this.$t('resetPassword.emailNotRegistered');
        this.isLoading = false;
      } catch (_error) {
        this.isLoading = false;
        /* this.userResponse = 'Error con el servidor.'; */
        this.userResponse = this.$t('resetPassword.serverError');
      }
    }
  }
};

</script>
<style lang="css" scoped>
    .info-content {
        width: 100%;
        float:left;
        text-align: center;
        padding: 10px;
        position: relative;
    }
    .info-item .return-link {
        margin: 5px auto 10px auto;
        border-radius: 40px;
        color: #797979;
        text-align: right;
        font-size: 8px;
        position:absolute;
        font-size: 13px;
        left: 2px;
        text-decoration: none;
        top: -7px;
    }
    .info-content .info-item .login-title{
        margin-top: 10px;
        margin-bottom: 0px;
        font-size: 30px;
        color: #00CCD1;
    }
    .info-content .description-password {
        font-size: 12px;
        color: var(--color-nickel) !important;
        margin: 30px 30px 20px;
    }
    .info-content .reset-button {
        margin: 30px auto 10px;
        font-size: 15px;
        border: none;
        background-color:var(--secondary);
        width: 30%;
        padding: 12px;
        border-radius: 40px;
        font-family: var(--primary-font);
        cursor:pointer;
        color: #ffffff;
    }
    .info-content .login-button:hover {
        background-color: var(--secondary-dark);
    }
    .button{
        margin: 20px 0;
    }
    .message-reply {
        font-size: 12px;
        color: var(--secondary);
        margin: 20px auto 0px;
        font-weight: bold;
    }

    .spinner-content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background-color: #ffffff78;
        display: none;
        opacity: 0;
    }
    .spinner-content.is-loading {
      display: block;
      opacity: 1;
    }

    .error-message {
      color: red;
      font-size: 12px;
      max-height: 0;
      margin-top: 20px;
    }
    .error-message.show-error {
      max-height: 500px;
    }
    .input-content {
      width: 60%;
      margin-top: 20px;
    }
    .info-content .description-help {
        font-size: 12px;
        color: var(--color-nickel) !important;
        margin: 0px auto;
    }
    @media (max-width: 1024px) {
    }

    @media (max-width: 768px) {
        .info-content .reset-password {
            font-size: 10px;
            width: 50%;
        }
        .info-content .error-password {
            font-size: 10px;
            width: 50%;
            }
    }
    @media (max-width: 640px) {
        .info-content .info-item .login-title{
            margin: 30px;
            font-size: 25px;
            }
        .info-content .mail-box {
            margin: 20px auto 20px auto;
            font-size: 11px;
            width: 70%;
        }
        .info-content .password-box {
            font-size: 11px;
            width: 70%;
            }
        .info-content .login-box {
            font-size: 12px;
            background-color:#E9007F;
            width: 40%;
            padding: 10px;
        }
        .info-content .reset-password {
            font-size: 7px;
            width: 50%;
        }
        .info-content .error-password {
            font-size: 7px;
            width: 50%;
            }
      .input-content{
        width: 90%;
      }
    }
    @media (max-width: 420px) {
        .info-content .info-item .login-title{
            margin: 20px;
            font-size: 25px;
            }
        .info-content .mail-box {
            margin: 20px auto 20px auto;
            font-size: 11px;
            width: 80%;
        }
        .info-content .password-box {
            margin: 20px auto 20px auto;
            font-size: 11px;
            width: 80%;
        }
    }

</style>
